import { StyleSheet, Text, View, Image, Dimensions, Alert } from "react-native";
import React, { useContext, useEffect, useState } from "react";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import Button from "./Button";

import {
  CodeField,
  Cursor,
  useBlurOnFulfill,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";

import {
  ConfirmEmailByUser,
  ForgotPassword,
  ResendConfirmationEmail,
} from "../services/Api/login";
import ButtonBack from "./ButtonBack";
import BetterAlert from "./BetterAlert";
import { AuthContext } from "../contexts/auth";
import { GlobalContext } from "../contexts/global";
import Toast from "react-native-toast-message";
import MessageTypeModal from "./MessageTypeModal";
import Loading from "./Loading";

const CELL_COUNT = 6;
const seconds = 120;

export default function CodeVerification({ route, navigation }) {
  const { tokenApi } = useContext(AuthContext);
  const { setLoading, loading } = useContext(GlobalContext);
  const [codeVerification, setCodeVerification] = useState("");
  const ref = useBlurOnFulfill({ codeVerification, cellCount: CELL_COUNT });
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value: codeVerification,
    setValue: setCodeVerification,
  });
  const [codeVerificationEmail, setCodeVerificationEmail] = useState(
    route.params?.codeVerification
  );
  const idUser = route.params.idUser;
  const nextPage = route.params.nextPage;
  const email = route.params.email;
  const [showAlert, setShowAlert] = useState({});
  const [timerResend, setTimerResend] = useState(seconds);
  const [showMessageModal, setShowMessageModal] = useState(false);

  const codeVerificationResendActionText = "Reenviar";
  //#region resend code verification
  useEffect(() => {
    const interval = setInterval(() => {
      if (timerResend > 0) {
        setTimerResend(timerResend - 1);
      }
      if (timerResend === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timerResend]);

  const onPressMessage = (messageType) => {
    setShowMessageModal(false);
    resetPasswordApi(messageType);
    setTimerResend(timerResend)
  };

  const resetPasswordApi = (messageType) => {
    if (timerResend > 0) return;
    setLoading({ show: true, message: "Reenviando email" });
    if (nextPage == "ChangePassword")
      ForgotPassword(email, tokenApi)
        .then((response) => {
          if (response.statusCode) {
            setCodeVerificationEmail(response.confirmationNumber);
            Toast.show({
              type: "info",
              text1: "Código de verificação reenviado",
            });
            setTimerResend(seconds);
          } else {
            let msgErro = response.reason;
            setShowAlert({
              type: "warning",
              title: "Atenção",
              message: msgErro,
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
          }
        })
        .catch((error) => {
          let { statusCode, reason } = error;
          setShowAlert({
            type: "alert",
            title: "Atenção",
            message: statusCode === 0 ? "Usuário não encontrado." : reason,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        })
        .finally(() => {
          setLoading({ show: false, message: "" });
        });
    else {
      setLoading({ message: "Enviando código de verificação", show: true });
      ResendConfirmationEmail(email, tokenApi, messageType ?? 0)
        .then((response) => {
          setCodeVerificationEmail(response.confirmationNumber);
          Toast.show({
            type: "info",
            text1: "Código de verificação reenviado",
          });
        })
        .catch((error) => {
          setShowAlert({
            type: "alert",
            title: "Erro",
            message: error.erro ?? error.reason,
            show: true,
            confirmText: "Ok",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        })
        .finally(() => {
          setLoading({
            message: "Enviando código de verificação, por favor espere.",
            show: false,
          });
        });
    }
  };
  //#endregion

  if (loading.show) return <Loading message={loading.message} />;

  return (
    <View style={styles.container}>
      <ButtonBack navigation={navigation} />
      <Image
        source={require("..//../assets/images/logo-viamais-login.png")}
        style={styles.logoPequeno}
      />

      <Text style={styles.inputLogin}>Verificação</Text>

      <CodeField
        ref={ref}
        {...props}
        value={codeVerification}
        onChangeText={setCodeVerification}
        cellCount={CELL_COUNT}
        rootStyle={styles.codeFieldRoot}
        keyboardType="number-pad"
        textContentType="oneTimeCode"
        renderCell={({ index, symbol, isFocused }) => (
          <Text
            key={index}
            style={[styles.cell, isFocused && styles.focusCell]}
            onLayout={getCellOnLayoutHandler(index)}
          >
            {symbol || (isFocused ? <Cursor /> : null)}
          </Text>
        )}
      />

      <Text style={styles.instructions}>
        {"Entre com seu código de verificação que enviamos para seu email"}
      </Text>

      <Button
        textoBotao={"Confirmar"}
        estilo={styles.button}
        onPress={() => {
          if (codeVerification.length < 6) {
            setShowAlert({
              type: "warning",
              title: "Atenção",
              message: "O código esperado deve conter 6 digitos",
              show: true,
              confirmText: "Vou verificar",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
            return;
          }
          if (codeVerification == codeVerificationEmail) {
            if (nextPage == "ChangePassword")
              navigation.navigate(nextPage, { idUser: idUser });
            else {
              ConfirmEmailByUser(idUser, tokenApi).then((response) => {
                if (response.statusCode) {
                  setShowAlert({
                    type: "success",
                    title: "Sucesso",
                    message:
                      nextPage == "Login"
                        ? "Usuário confirmado com sucesso."
                        : "Cadastrado com sucesso, faça o login",
                    show: true,
                    confirmText: "OK",
                    pressConfirm: () => {
                      setShowAlert({ ...showAlert, show: false });
                      navigation.navigate(nextPage);
                    },
                  });
                } else {
                  setShowAlert({
                    type: "alert",
                    title: "Atenção",
                    message: response.reason,
                    show: true,
                    confirmText: "OK",
                    pressConfirm: () => {
                      setShowAlert({ ...showAlert, show: false });
                    },
                  });
                }
              });
            }
          } else {
            setShowAlert({
              type: "alert",
              title: "Atenção",
              message: "Código errado, por favor tente novamente",
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
          }
        }}
      />

      <Button
        textoBotao={
          codeVerificationResendActionText +
          (timerResend > 0
            ? " (" + timerResend.toString().padStart(2, 0) + ")"
            : "")
        }
        onPress={() => setShowMessageModal(true)}
        estilo={[
          styles.button,
          {
            marginTop: 16,
            backgroundColor:
              timerResend > 0 ? Colors.GRAY_LIGHT : Colors.SECONDARY,
          },
        ]}
      />
      <BetterAlert {...showAlert} />
      <MessageTypeModal
        show={showMessageModal}
        onPressMessage={(messageValue) => onPressMessage(messageValue)}
      />
      <View style={{ justifyContent: "flex-end" }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
          <View>
            <Text style={{ width: 50, textAlign: "center" }}>Ou</Text>
          </View>
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
        </View>
        <Text
          style={{
            fontSize: Fonts.FONT_SIZE_16,
            textAlign: "center",
            marginTop: 15,
          }}
        >
          Lembrou a senha?{" "}
        </Text>
        <Text
          onPress={() => navigation.navigate("Login")}
          style={{
            fontSize: Fonts.FONT_SIZE_22,
            textAlign: "center",
            marginTop: 1,
            fontWeight: "bold",
          }}
        >
          Faça Login
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  logoPequeno: {
    marginBottom: 10,
    resizeMode: "contain",
    width: 240,
    height: 74,
  },
  inputLogin: {
    fontSize: Fonts.FONT_SIZE_25,
    textAlign: "center",
    // marginBottom: 20,
    // fontWeight: 'bold',
    color: Colors.WELCOME_TEXT,
  },
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: Colors.WHITE,
  },
  button: {
    width: "70%",
  },
  instructions: {
    fontSize: Fonts.FONT_SIZE_14,
    textAlign: "center",
    padding: 16,
  },
  root: { flex: 1, padding: 20 },
  title: { textAlign: "center", fontSize: 30 },
  codeFieldRoot: { marginTop: 20 },
  cell: {
    width: 48,
    height: 48,
    lineHeight: 38,
    fontSize: 24,
    borderWidth: 1,
    borderColor: Colors.GRAY_DARK,
    textAlign: "center",
    margin: 4,
    borderRadius: 8,
  },
  focusCell: {
    borderColor: "#000",
  },
});
